import React, { FC } from 'react';
import { CloseButton, CloseIcon, HeaderElem, Title } from './Header.styles';

interface IHeader {
  className?: string;
  title?: string;
  onClick: () => void;
  hasBorder?: boolean;
}

const Header: FC<IHeader> = ({ className, title, onClick, hasBorder = false }) => (
  <HeaderElem id="HeaderElem" hasCloseOnly={!title} {...{ className, hasBorder }}>
    {title ? <Title>{title}</Title> : null}
    <CloseButton id="CloseButton" autoFocus {...{ onClick }}>
      <CloseIcon id="CloseIcon" />
    </CloseButton>
  </HeaderElem>
);

export default Header;
